import { Choice } from '@cmsgov/ds-medicare-gov';
import { PropsWithChildren } from 'react';
import '../css/checkbox.css';
import cloneObject from '../functions/clone.object';
import the from '../objects/the';

interface CheckboxProps {
    errorMessage?: string | null
    title: string
    checked?: boolean
    className?: string
    name: string
    onBlur: (event: any) => void
    onChange: (event: any) => void
    type: any
    value: any
    inputRef?: any
}

const Checkbox = (props: PropsWithChildren<CheckboxProps>) => {
    const clonedProps: any = cloneObject(props);
    delete clonedProps.errorMessage;
    return <>
        <div>
            <Choice
                labelClassName={props.errorMessage ? 'error' : ''}
                {...clonedProps}
            >
                {props.title}
            </Choice>
            {props.children}
            <div style={{
                color: the.color.darkRed,
                display: props.errorMessage ? 'block' : 'none',
                fontFamily: 'Rubik',
                fontSize: 14,
            }}>
                {props.errorMessage}
            </div>
        </div>
    </>
}

export default Checkbox;